import { queryKeys } from "@/lib/queryKeys";
import { setOpenedEvent } from "@/stores/eventStore";
import { useAgenda } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useErrorToast from "../utils/useErrorToast";

const useDeleteAgendaEvent = () => {
    const agenda = useAgenda();
    const showErrorToast = useErrorToast();
    const queryClient = useQueryClient();

    const deleteAgendaEvent = useMutation({
        mutationFn: async (eventId: string) => {
            const deleted = await agenda.deleteAgendaItem(eventId);

            if (!deleted) {
                throw new Error("Agenda item deletion refused by the provider");
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.agendaEvents.all(),
            });
            setOpenedEvent(undefined);
        },
        onError: (error) => {
            console.error(error);
            showErrorToast({
                titleTranslationKey: "errors.agenda.delete",
            });
        },
    });

    return {
        deleteAgendaEvent,
    };
};

export default useDeleteAgendaEvent;
